<template>
  <div class="wrap" style="overflow: hidden">
    <div class="content">
      <div class="box" style="margin-top:20px">
        <h3>
          供应商线上预约通道
          <!-- <yd-button @click.native="addContract()" bgcolor="#2f6fff" color="#fff" shape="circle" style="position: absolute;right: 5px;">添加合同</yd-button>-->
        </h3>
        <p>
          <img src="../assets/img/supplier_no.png" />{{supplierUser.supplier_no}}
        </p>
        <p>
          <img src="../assets/img/supplier_name.png" />{{supplierUser.supplier_name}}
        </p>
        <p><img src="../assets/img/supplier_user.png" />{{supplierUser.user_name}}
          <el-link type="success" plain size="mini"> {{supplierUser.status}}</el-link>
        </p>

      </div>
      <div class="title">
        预约日期
        <p>{{ this.startTime }} ~ {{ this.endTime }}</p>
      </div>
      <div class="my_nav">
        <ul>
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="index in swiperCount" :key="index">
              <li v-for="(item, index) in allLi" :key="index" :style="item.state === 1?'background:#e7eeff':'background:#ffffff'">
                <div v-if="item.state === 1" @click="selectLi(item.id)">
                  <p v-if="item.state === 1" style="color: #004EFF;">
                    {{ item.oName }}
                  </p>
                  <h3 v-if="item.state === 1" style="color: #004EFF;font-weight:bold">
                    {{ item.count }}
                  </h3>
                </div>
                <div v-else-if="item.state === 0" @click="selectLi(item.id)">
                  <p>{{ item.oName }}</p>
                  <h3>{{ item.count }}</h3>
                </div>
                <div v-else>
                  <p style="background: #ebebeb !important;
    color: #999;">
                    {{ item.oName }}
                  </p>
                  <h3 style="background: #ebebeb !important;
    color: #999;">
                    {{ item.count }}
                  </h3>
                </div>
              </li>
            </swiper-slide>
          </swiper>
        </ul>
      </div>
      <div class="title">预约时间</div>
      <div class="xuanze xuanze1">
        <div v-for="(item, index) in alldiv" :key="index">
          <div v-if="item.state === 1" class="mynone">
            <p>已约满</p>
            <!-- <h3>{{ item.orderCount }}</h3> -->
            <h3>{{item.beginTime.slice(10,16)}}~{{item.endTime.slice(10,16)}}</h3>
          </div>
          <div v-else-if="item.leftCount === 0">
            <p>{{ item.orderUserName }}</p>
            <p>余 {{ item.leftCount }}</p>
            <!-- <h3>{{ item.totalCount }}</h3> -->
            <h3>{{item.beginTime.slice(10,16)}}~{{item.endTime.slice(10,16)}}</h3>
          </div>
          <div v-else class="myactive" @click="selectdiv(item, index)">
            <p>{{ item.orderUserName }}</p>
            <p>余 {{ item.leftCount }}</p>
            <!-- <h3>{{ item.totalCount }}</h3> -->
            <h3>{{item.beginTime.slice(10,16)}}~{{item.endTime.slice(10,16)}}</h3>
          </div>
        </div>
        <div v-if="alldiv.length == 0">暂无预约时间信息</div>
      </div>
      <div style="clear:both"></div>
      <yd-popup v-model="show2" position="center" width="90%">
        <div style="background-color:#fff;">
          <img src="../assets/img/fail.png" alt />
          <p style="color:#000;margin-bottom: 10px;">
            网络异常预约失败,请重新预约！
          </p>
          <p style="text-align: center;padding:10px 0 20px;">
            <yd-button @click.native="show2 = false">确 认</yd-button>
          </p>
        </div>
      </yd-popup>
    </div>
    <yd-tabbar class="tabbar-footer" active-color="#004EFF">
      <yd-tabbar-item title="首页" link="#" active>
        <yd-icon name="home" slot="icon" size="0.54rem" color=""></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="我的预约" link="supplierList">
        <yd-icon name="checkoff" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
      <yd-tabbar-item title="个人中心" link="supplierInfo">
        <yd-icon name="ucenter-outline" slot="icon" size="0.54rem"></yd-icon>
      </yd-tabbar-item>
    </yd-tabbar>
  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    const self = this;
    return {
      swiperCount: 0,
      supplierStatus:0,
      supplierMsg:"",
      supplierUser:{
         supplier_no:'',
         supplier_name:'',
         user_name:'',
         status:''

      },
      user:'',
      swiperOption: {
        slidesPerView: 1,
        mousewheel: true,
        grabCursor: true,
        addressList: [],
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          slideNextTransitionStart: function() {
            //预约日期右滑动
            var gtime = new Date(self.endTime);
            var year = gtime.getFullYear();
            var month = gtime.getMonth() + 1;
            var day = gtime.getDate() + 1;
            if (month < 10) {
              month = "0" + month;
            }
            if (day < 10) {
              day = "0" + day;
            }
            gtime = year + "-" + month + "-" + day;
            if (self.timelimit == "0") {
              self.getTimeInfo(gtime, 1);
            } else {
              self.getNowInfo(gtime, 0);
            }
          },
          slidePrevTransitionStart: function() {
            //预约日期左滑
            var gtime = new Date(self.startTime);
            var year = gtime.getFullYear();
            var month = gtime.getMonth() + 1;
            var day = gtime.getDate() - 2;
            if (month < 10) {
              month = "0" + month;
            }
            if (day < 10) {
              day = "0" + day;
            }
            gtime = year + "-" + month + "-" + day;
            if (self.timelimit == "0") {
              self.getTimeInfo(gtime, 1);
            } else {
              self.getNowInfo(gtime, 1);
            }
          }
        }
      },
      show1: false,
      show2: false,
      flag: 1,
      alldiv: [],
      timelimit: "",
      startTime: "",
      endTime: "",
      startdate: "",
      enddate: "",
      allLi: [],
      allList:{},
      appointmentDate: "",
      appointmentTime: "",
    };
  },
  methods: {
    addContract() {
      this.$dialog.confirm({
        title: '提示',
        mes: '仅需添加当天新办理的合同，按照合同签约审查审批表信息录入！',
        opts: [
          {
            txt: '取消',
            color: false,
            callback: () => {}
          },
          {
            txt: '确定',
            color: true,
            callback: () => {
              this.$router.push({ path: "/supplierAdd",query:{supplierUser:this.supplierUser} });
            }
          }
        ]
      });
    },
    //预约日期
    getOrderInfo() {
      axios({
        method: "get",
        url: baseUrl + "wxOrder"
      }).then(resp => {
        if (resp.data.error_code == "0") {
            resp.data.days.forEach((v)=>{
              v.oName = this.ChWeek(v.orderDate)
              v.count = v.orderDate.slice(5,10),
              v.state = 0;
            })
            this.endTime=resp.data.days[resp.data.days.length-1].orderDate
            this.startTime=resp.data.days[0].orderDate
            this.swiperCount = 1;
            // this.swiperCount = this.WeeksBetw(parseInt(resp.data.data.days[resp.data.data.days.length-1].id),parseInt(resp.data.data.days[0].id))
            this.allList = resp.data
            this.allLi = resp.data.days
            this.alldiv = resp.data.periods[resp.data.days[0].id]
        } else {
          this.$dialog.toast({ mes: "获取预约日期失败", timeout: 1500 });
        }
      });
    },
    //根据时间戳之差获取周数
    WeeksBetw(dt2, dt1) {
      return parseInt(Math.abs(dt2 - dt1) /100000/ 1000 / 60 / 60 / 24 / 7);
    },
    MonthAndDay(timestamp) {
        let data = new Date(parseInt(timestamp.slice(0,13)))
        let year = data.getFullYear()
        let month = data.getMonth()+1
        let day = data.getDate()
        //补位
        const formatNumber = n =>{
          n = n.toString()
          return n[1] ? n : '0' + n
        }
        return [year,month,day].map(formatNumber).join('-')
    },
      //根据时间戳获取周几
      ChWeek(timestamp) {
        let data = new Date(timestamp)
        let day = data.getDay()
        let weekday =['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
        return weekday[day]
    },
    // tab切换
    selectLi(id) {
      if(this.supplierStatus=='3'||this.supplierStatus=='4') {
        this.showMsg();
        return;
      }
      this.alldiv = this.allList.periods[id];
      this.allLi.forEach((item) => {
        if(item.id === id){
          item.state = 1
        }else{
          item.state = 0
        }
      });
    },
    showMsg(){
      this.$dialog.confirm({
        title: '提示',
        mes: this.supplierMsg,
        opts: [
          {
            txt: '取消',
            color: false,
            callback: () => {}
          },
          {
            txt: '确定',
            color: true,
            callback: () => {

            }
          }
        ]
      });
    },
    // tab切换
    selectdiv(period, index, sName1) {
      if(this.supplierStatus=='3'||this.supplierStatus=='4') {
        this.showMsg();
        return;
      }
      this.appointmentTime = period;
      for (let key in this.alldiv) {
        if (this.alldiv[key].state != 1) {
          this.alldiv[key].state = 0;
        }
      }
      if (this.alldiv[index].state != 1) {
        this.alldiv[index].state = 2;
      }
      //跳转合同页面
      this.$router.push({path:'/supplierContract',query: {period: period}})
    },
    //获取微信Code
    getcode() {
      window.localStorage.clear();
      let queryParams = this.extractQueryParams(window.location.href);
      this.code = queryParams.code;
      let appid = process.env.WX_APPID;
      let redirect_uri = process.env.WX_REDIRECT_URI;
      if (this.code == "" || this.code == undefined) {
        let authParams = `?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${"code"}&state=${"123"}&scope=${"snsapi_userinfo"}#wechat_redirect`;
        location.replace(
          "https://open.weixin.qq.com/connect/oauth2/authorize" + authParams
        );
      } else {
        axios({
          method: "get",
          url: baseUrl + "getopenid?code=" + this.code
        }).then(resp => {
          if (resp.data.error_code == "0") {
            window.localStorage.setItem("openid", resp.data.openid);
          } else {
            this.$dialog.toast({ mes: "获取openId失败", timeout: 1500 });
            return;
          }
        });
      }
    },
    extractQueryParams(url) {
      let queryParams = {};
      if (url.includes("?")) {
        let queryString = url.substr(url.indexOf("?") + 1);
        let pairs = queryString.split("&");
        for (let pair of pairs) {
          let splitArray = pair.split("=");
          let key = splitArray[0];
          let value = splitArray[1];
          if (value.indexOf("#") > -1) {
            value = value.substring(0, value.indexOf("#"));
          }
          queryParams[key] = value;
        }
      }
      return queryParams;
    },
    getOpenId(code) {
      // 通过code获取 openId等用户信息，/api/user/wechat/login 为后台接口
      axios({
        method: "get",
        url: baseUrl + "getopenid?code=" + code
      }).then(resp => {
        if (resp.data.error_code == "0") {
          window.localStorage.setItem("openid", resp.data.openid);
        } else {
          this.$dialog.toast({ mes: "获取openId失败", timeout: 1500 });
        }
      });
    },

    getSupplierInfo(){
      let userId = window.localStorage.getItem("checkUserId")
       axios({
          method: "get",
          url: baseUrl + "suppplierUserInfo?userId=" + userId
        }).then(resp => {
          if (resp.data.error_code == "0") {
            this.supplierUser = resp.data.data
          } else {
            this.$dialog.toast({ mes: "获取供应商信息失败", timeout: 1500 });
            return;
          }
        });
    },

    //扫码方法
    checkCar() {
      this.$dialog.loading.open('验证时效中...');
      this.$dialog.loading.close();
      // return this.$dialog.toast({ mes: "不在时效中..."});
      this.$router.push({path:'/orderConfirm',queryId:{id:'111'}});
      axios({
        method: "get",
        url: baseUrl + "scannerQrcode?username=" + this.checkUserId
      }).then(resp => {
        if (resp.data.error_code == "0") {
          let data = resp.data.data;
          wx.config({
            debug: false,
            appId: data.appId, // 必填,公众号的唯一标识
            timestamp: data.timestamp, // 必填,生成签名的时间戳
            nonceStr: data.nonceStr, // 必填,生成签名的随机串
            signature: data.signature, // 必填,签名
            jsApiList: ["scanQRCode", "checkJsApi"] // 必填,需要使用的JS接口列表
          });
          wx.ready(function() {
            // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
            // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
            wx.checkJsApi({
              // 判断当前客户端版本是否支持指定JS接口
              jsApiList: ["scanQRCode"],
              success: function(res) {
                // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    // 微信扫一扫接口
                    desc: "scanQRCode desc",
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function(res) {
                      window.location.replace(res.resultStr);
                    }
                  });
                } else {
                  alert("抱歉，当前客户端版本不支持扫一扫");
                }
              },
              fail: function(res) {
                // 检测getNetworkType该功能失败时处理
                alert("抱歉，当前客户端版本不支持扫一扫");
              }
            });
          });
        }
      });
    },
    getUserStatus(){
      axios({
        method: "get",
        url:
          baseUrl +
          "getUserStatus?username=" +
          this.user
      }).then((resp) => {
        if (resp.data.error_code != "1") {
          this.supplierStatus=resp.data.error_code;
          // if(resp.data.error_code=="0"){
          //   if(resp.data.data.grantDateExpired){
          //     this.supplierMsg='委托书即将过期，请更新授权委托书！'
          //   }
          // }else if(resp.data.error_code=="2"){
          //   this.supplierMsg='委托书过期，请更新授权委托书！'
          // }
          // else
            if(resp.data.error_code=="3"){
            this.supplierMsg='审批未通过，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！'
          }else if(resp.data.error_code=="4"){
            this.supplierMsg='管理员未审批，请耐心等待，如果需要紧急办理请拨打电话：029-86595044，请联系管理员！'
          }
        }else {
          if(resp.data.error_msg){
            this.$dialog.toast({ mes: resp.data.error_msg, timeout: 1500 });
          }else{
            this.$dialog.toast({ mes: '获取信息失败', timeout: 1500 });
          }
        }
      });
    }
  },
  //定义这个sweiper对象
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.user=window.localStorage.getItem("user");
    this.getUserStatus();
    this.getOrderInfo();
    this.getSupplierInfo();

  }
};
</script>

<style scoped>
.box {
  width: 92%;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px 3px 40px 0px rgba(24, 95, 255, 0.11);
  border-radius: 8px;
  margin: auto;
  margin-top: -20px;
  z-index: 99;
  position: relative;
  text-align: left;
}
.box h3 {
  padding: 10px;
  font-size: 16px;
}
.box h3 .yd-btn-primary:not(.yd-btn-loading) {
  float: right;
  padding: 0px 18px;
  border-radius: 80px;
  height: 27px;
  line-height: 27px;
  box-shadow: 0px 1px 11px rgb(193, 212, 253);
}
.box p {
  color: #999999;
  font-size: 14px;
  padding-left: 10px;
  line-height: 28px;
}
.box p img {
  width: 18px;
  margin-right: 8px;
}
.title {
  text-align: left;
  padding: 30px 16px 20px;
  font-size: 16px;
  font-weight: bold;
}
.title {
  padding: 20px 16px 20px;
}
.xuanze {
  width: 100%;
  height: 40px;
  display: flex;
}
.xuanze div {
  background: #f5f5f5;
  flex: 1;
  background: #fff;
  height: 40px;
  margin: 0 16px;
  line-height: 40px;
  border-radius: 4px;
  font-size: 14px;
}
.xuanze1 {
  width: 100%;
  height: 180px;
  display: block;
}
.wrap /deep/ .yd-slider-item {
  display: flex;
}
.xuanze1 .myactive {
  background: #e7eeff !important;
  color: rgba(47, 111, 255, 1);
  border: 1px solid rgba(47, 111, 255, 1);
}
.xuanze1 .myactive h3 {
  background: #e7eeff !important;
  color: rgba(47, 111, 255, 1);
}
.xuanze1 .mynone {
  background: #ebebeb !important;
  color: #999;
}
.wrap /deep/ .yd-slider-item img {
  height: 200px;
}
.xuanze1 > div {
  background: none;
  float: left;
  height: 80px;
  display: block;
  margin: 0 6px 10px;
  width: 45%;
}
.xuanze1 div div {
  height: 80px;
  display: block;
  margin: 0 6px;
  width: 100%;
  line-height: 24px;
  border-radius: 4px;
  font-size: 14px;
  float: left;
}
.xuanze1 div h3 {
  font-weight: normal;
  font-size: 16px;
  color: #999999;
}

.my_nav {
  width: 100%;
  /* overflow-x: scroll; */
}
.my_nav ul {
  display: flex;
}
.my_nav ul li {
  height: 52px;
  background: rgba(255, 255, 255, 1);
  text-align: center;
  flex: 1;
}

.my_nav ul li div {
  width: 50px;
}

.my_nav ul li h3 {
  color: #b2b9c4;
  font-size: 14px;
  /* width: 54px; */
  line-height: 24px;
  text-align: center;
  color: rgba(178, 185, 196, 1);
}
.my_nav ul li p {
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #b2b9c4;
  font-size: 12px;
  line-height: 24px;
  padding-top: 4px;
}
.wrap /deep/ .yd-cell-left {
  color: #000;
  font-size: 16px;
  width: 70px;
}
.wrap /deep/ input {
  text-align: right;
  font-size: 16px;
}
.wrap /deep/ .yd-cell {
  position: relative;
}
.yd-cell:after {
  height: 2px;
}
.wrap /deep/ .yd-cell b {
  position: absolute;
  top: 0.5rem;
  left: 0.12rem;
  color: #dc4d4d;
  z-index: 11;
}
.wrap /deep/ .yd-cell-box {
  margin-bottom: 1px;
}

.wrap /deep/ .swiper-wrapper > div {
  width: 100vw !important;
  display: flex !important;
}
.wrap /deep/ .yd-cell-right input[type='text'] {
  height: 1.2rem;
}
.mybtn {
  background: #ffffff;
  height: 70px;
  padding-top: 10px;
  margin-top: 10px;
}
.yd-popup-center.yd-popup-show img {
  width: 20%;
  padding: 20px 0 6px;
}
.wrap /deep/ .title p {
  float: right;
  font-size: 14px;
  color: #666;
  font-weight: normal;
  padding: 4px 0px;
}
.wrap /deep/ .mytip {
  text-align: left;
  background: #ffe7e7 !important;
  width: 94%;
  margin: 10px auto;
  padding: 8px;
  border-radius: 8px;
}
.wrap /deep/ .mytip p {
  font-size: 12px;
  font-weight: normal;
  color: rgb(255, 47, 47);
  line-height: 15px;
  margin: 6px 0;
}

.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/supplier-index.vue